export const tableData = {
  content: [
    {
      unique_id: "67af91fd85b6133e35521bed",
      filename: "fax1798059520.pdf",
      status: "New",
      processed_by: null,
      pdfFile: null,
      createdDatetime: "2025-02-14T18:57:01.283393985",
      createdByUser: "Scheduler",
      updatedDatetime: null,
      updatedByUser: null,
      lastSynced: null,
      user: null,
      processed_by_email: null,
      childpdf: null,
      location: {
        name: "Bedard Medical Auburn",
        id: "OLe3e1be00c21b9328d414528a710858bd",
        npi: null,
        description: null,
      },
      id: "UN94aef010382bf3386de493f4a6c975fa",
      locked: false,
      deleted: false,
      receivedOn: "2025-02-13T21:24:46+00:00",
      alias: "Medical Equipment & Supplies",
      tags: [],
      faxId: "828095400",
      ocrprocessed: true,
      faxLine: "2075445048",
      callerId: "2069716778",
      archived: false,
      pageCount: 2,
    },
    {
      unique_id: "67af91fe85b6133e35521c1b",
      filename: "fax1798074481.pdf",
      status: "New",
      processed_by: null,
      pdfFile: null,
      createdDatetime: "2025-02-14T18:57:02.358935915",
      createdByUser: "Scheduler",
      updatedDatetime: null,
      updatedByUser: null,
      lastSynced: null,
      user: null,
      processed_by_email: null,
      childpdf: null,
      location: {
        name: "Bedard Medical Auburn",
        id: "OLe3e1be00c21b9328d414528a710858bd",
        npi: null,
        description: null,
      },
      id: "UNd8ca2110382b154b1c1460102f4ec6a2",
      locked: false,
      deleted: false,
      receivedOn: "2025-02-13T21:39:51+00:00",
      alias: "Medical Equipment & Supplies",
      tags: [],
      faxId: "828103455",
      ocrprocessed: true,
      faxLine: "2075445048",
      callerId: "2069716647",
      archived: false,
      pageCount: 3,
    },
    {
      unique_id: "67af91fc85b6133e35521bd4",
      filename: "fax1798076389.pdf",
      status: "New",
      processed_by: null,
      pdfFile: null,
      createdDatetime: "2025-02-14T18:57:00.543257494",
      createdByUser: "Scheduler",
      updatedDatetime: null,
      updatedByUser: null,
      lastSynced: null,
      user: null,
      processed_by_email: null,
      childpdf: null,
      location: {
        name: "Bedard Medical Auburn",
        id: "OLe3e1be00c21b9328d414528a710858bd",
        npi: null,
        description: null,
      },
      id: "UN11e65110382b51da99642bcd3eab3dcc",
      locked: false,
      deleted: false,
      receivedOn: "2025-02-13T21:41:48+00:00",
      alias: "Medical Equipment & Supplies",
      tags: [],
      faxId: "828104520",
      ocrprocessed: true,
      faxLine: "2075445048",
      callerId: "6305663210",
      archived: false,
      pageCount: 2,
    },
    {
      unique_id: "67af91fd85b6133e35521c00",
      filename: "fax1798088527.pdf",
      status: "New",
      processed_by: null,
      pdfFile: null,
      createdDatetime: "2025-02-14T18:57:01.839677323",
      createdByUser: "Scheduler",
      updatedDatetime: null,
      updatedByUser: null,
      lastSynced: null,
      user: null,
      processed_by_email: null,
      childpdf: null,
      location: {
        name: "Bedard Medical Auburn",
        id: "OLe3e1be00c21b9328d414528a710858bd",
        npi: null,
        description: null,
      },
      id: "UNc9728110382b3b3a17f4c4cfae385482",
      locked: false,
      deleted: false,
      receivedOn: "2025-02-13T21:55:35+00:00",
      alias: "Medical Equipment & Supplies",
      tags: [],
      faxId: "828111431",
      ocrprocessed: true,
      faxLine: "2075445048",
      callerId: "2069716647",
      archived: false,
      pageCount: 3,
    },
    {
      unique_id: "67af91fc85b6133e35521bca",
      filename: "fax1798094184.pdf",
      status: "New",
      processed_by: null,
      pdfFile: null,
      createdDatetime: "2025-02-14T18:57:00.092427019",
      createdByUser: "Scheduler",
      updatedDatetime: null,
      updatedByUser: null,
      lastSynced: null,
      user: null,
      processed_by_email: null,
      childpdf: null,
      location: {
        name: "Bedard Medical Auburn",
        id: "OLe3e1be00c21b9328d414528a710858bd",
        npi: null,
        description: null,
      },
      id: "UN0b6ea110382b7e0987c4024568f446eb",
      locked: false,
      deleted: false,
      receivedOn: "2025-02-13T22:02:00+00:00",
      alias: "Medical Equipment & Supplies",
      tags: [],
      faxId: "828114432",
      ocrprocessed: true,
      faxLine: "2075445048",
      callerId: "2069716647",
      archived: false,
      pageCount: 3,
    },
    {
      unique_id: "67af91fc85b6133e35521bdf",
      filename: "fax1798106781.pdf",
      status: "New",
      processed_by: null,
      pdfFile: null,
      createdDatetime: "2025-02-14T18:57:00.857607655",
      createdByUser: "Scheduler",
      updatedDatetime: null,
      updatedByUser: null,
      lastSynced: null,
      user: null,
      processed_by_email: null,
      childpdf: null,
      location: {
        name: "Bedard Medical Auburn",
        id: "OLe3e1be00c21b9328d414528a710858bd",
        npi: null,
        description: null,
      },
      id: "UN586ad110382b08bb3ca42651fe3086d6",
      locked: false,
      deleted: false,
      receivedOn: "2025-02-13T22:16:43+00:00",
      alias: "Medical Equipment & Supplies",
      tags: [],
      faxId: "828121270",
      ocrprocessed: true,
      faxLine: "2075445048",
      callerId: "2069716778",
      archived: false,
      pageCount: 2,
    },
  ],
  pageable: {
    sort: {
      empty: false,
      sorted: true,
      unsorted: false,
    },
    offset: 0,
    pageNumber: 0,
    pageSize: 10,
    paged: true,
    unpaged: false,
  },
  totalPages: 1,
  totalElements: 6,
  last: true,
  size: 10,
  number: 0,
  sort: {
    empty: false,
    sorted: true,
    unsorted: false,
  },
  first: true,
  numberOfElements: 6,
  empty: false,
};
